import { TImageField, TStringField, TDateField } from '../../../types/types';
import { isEmptyObject } from '../../../utils/checkEmptyObject';
import { TSocialMediaBarProps } from '../../@shared/socialMediaBar/types/socialMediaBar.types';
import { TFairHeroFields, TFairHeroProps } from '../types/fairHero.types';
import { TSaveCalendarEventProps } from '../../@shared/saveCalendarEvent/types/saveEvent.types';

export class FairHeroModel {
  private readonly fields?: TFairHeroFields;

  constructor(props: TFairHeroProps) {
    this.fields = props?.fields;
  }

  get socialMediaBarProps(): TSocialMediaBarProps | undefined {
    return isEmptyObject(this.fields?.socialMediaBar) ? undefined : this.fields?.socialMediaBar;
  }

  get title(): TStringField {
    return this.fields?.title as TStringField;
  }

  get shortDescription(): TStringField {
    return this.fields?.shortDescription as TStringField;
  }

  get image(): TImageField {
    return this.fields?.heroBannerImage as TImageField;
  }

  get mobileImage(): TImageField {
    return this.fields?.mobileHeroBannerImage as TImageField;
  }
  get startDate(): TDateField {
    return this.fields?.startDate || {};
  }

  get endDate(): TDateField {
    return this.fields?.endDate || {};
  }

  get calendarDetails(): TSaveCalendarEventProps['calendarDetails'] {
    return this.fields?.calendarDetails || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
